import { i18n } from "@/main";
import { Files } from "./api";

/* FORMAT CENTS TO EUROS */
export function formatCentsToEuros(cents: number, locale = "fr-FR"): string {
  const euros = cents / 100;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "EUR",
  }).format(euros);
}

export function getFileData(files: Files, key: string) {
  return files.find((file) => {
    const typedFile = file;
    const filename = typedFile.filename === key;
    if (filename) {
      return filename;
    }
  });
}

export function showError(event?: {
  error: string[] | { message: string };
  errorId: string;
}) {
  if (!event) {
    return;
  }
  let message = i18n.t("error.unknown") as string;

  if (Array.isArray(event.error)) {
    if (
      event.error.length > 0 &&
      (event.error[0] == "Email domain not allowed" ||
        event.error[0] == "Email address with + character not allowed")
    ) {
      message = i18n.t("error.email_not_allowed") as string;
    }
  } else if (
    event.error.message ==
    "Un ou plusieurs IMEI renseigné(s) est (sont) invalides ou a (ont) déjà été utilisé(s)"
  ) {
    message = i18n.t("error.imei_invalid") as string;
  } else if (
    event.error.message == "Vous avez déjà attribué ce numéro client !"
  ) {
    message = i18n.t("error.clientAlreadyExists") as string;
  } else if (event.error.message == "user not found") {
    message = i18n.t("error.imei_invalid") as string;
  } else if (event.error.message == "Compte invalide ou inexistant !") {
    message = i18n.t("error.clientAlreadyExists") as string;
  } else {
    message = event.errorId.toString();
  }

  return message;
}

interface CustomCssVariables {
  body_background_color: string;
  transparence_nav_link: string;
  color_top_link: string;
  color_top_bg_link: string;
  primary_color_bg: string;
  primary_color_txt: string;
  secondary_color_bg: string;
  secondary_color_txt: string;
  color_input_border: string;
  color_input_bg: string;
  color_input_txt: string;
  color_input_bg_focus: string;
  color_input_bg_error: string;
  color_error_txt: string;
  color_bg_button_back: string;
  color_text_button_back: string;
  border_radius_buttons: string;
  border_radius_fields: string;
  border_radius_popup: string;
}

const cleanHexa = (hexa: string) => {
  if (hexa) return hexa?.replace("#", "");
};

export function setCustomCssVariables(custom: CustomCssVariables) {
  const style = document.createElement("style");
  style.append(
    document.createTextNode(
      `:root {
            --border-radius-field: ${custom.border_radius_fields || 4}px;
            --border-radius-popup: ${custom.border_radius_popup || 4}px;
            --border-radius-button: ${custom.border_radius_buttons || 4}px;
            --bg-color: #${cleanHexa(custom.body_background_color || "FFFFFF")};
            --menu-transparancy : 0.${custom.transparence_nav_link || 0};
            --menu-color-links : #${cleanHexa(
              custom.color_top_link || "FFFFFF"
            )};
            --menu-color-background :  #${cleanHexa(custom.color_top_bg_link)};
            --primary-color-background : #${cleanHexa(custom.primary_color_bg)};
            --primary-color-text : #${cleanHexa(custom.primary_color_txt)};
            --secondary-color-background : #${cleanHexa(
              custom.secondary_color_bg
            )};
            --secondary-color-text : #${cleanHexa(custom.secondary_color_txt)};
            --input-border-color : #${cleanHexa(custom.color_input_border)};
            --input-bg-color : #${cleanHexa(custom.color_input_bg)};
            --input-text-color : #${cleanHexa(custom.color_input_txt)};
            --input-bg-color-focus : #${cleanHexa(custom.color_input_bg_focus)};
            --input-bg-color-error : #${cleanHexa(custom.color_input_bg_error)};
            --button-back-background-color : #${cleanHexa(
              custom.color_bg_button_back
            )};
            --input-error-text-color : #${cleanHexa(custom.color_error_txt)};
            --button-back-text-color : #${cleanHexa(
              custom.color_text_button_back
            )};
       }`
    )
  );
  document.head.append(style);
}
